var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-title',{attrs:{"type":_vm.titleTag,"is-paragraph":_vm.isParagraph,"data-test":_vm.dataTest || null}},[(_vm.showPrefixIcon)?_c('img',{attrs:{"src":require("@/assets/images/icons/svg/tilde.svg")}}):_vm._e(),_vm._v(" "),(!_vm.title)?_vm._t("default"):[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }